'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _group = require('./group');

var _group2 = _interopRequireDefault(_group);

var _pack = require('./pack');

var _pack2 = _interopRequireDefault(_pack);

var _util = require('../util');

var _util2 = _interopRequireDefault(_util);

var _queryString = require('query-string');

var _queryString2 = _interopRequireDefault(_queryString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var axios = _util2.default.axios,
    cleanPacks = _util2.default.cleanPacks;
exports.default = {
  Pack: _pack2.default,
  Group: _group2.default,
  getCart: getCart,
  deletePacks: deletePacks,
  favoriteAjax: favoriteAjax,
  submit: submit,
  getVariant: getVariant
};


function getCart() {
  // return Promise.resolve({ 
  //   data: require('../../data').default.cartData 
  // })
  return axios({
    url: '/app/cart'
  });
}

function deletePacks(packs) {
  var query = _queryString2.default.stringify({
    "packId": cleanPacks(packs).map(function (pack) {
      return pack.id;
    })
  });
  return axios({
    url: '/app/cart/packs?' + query,
    method: 'delete'
  });
}

function favoriteAjax(packs) {
  var ids = packs.map(function (pack) {
    return pack.id;
  });
  return axios({
    url: '/app/cart/transfer',
    method: 'POST',
    json: {
      "to": "FAVORITE",
      "packIds": ids
    }
  });
}

function submit(packs) {
  return axios({
    url: '/app/order/preview',
    method: 'POST',
    json: {
      packs: cleanPacks(packs)
    }
  });
}

function getVariant(productId) {
  return axios({
    url: '/app/product/' + productId + '/spvs',
    method: 'GET'
  });
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@beastshop/cart/lib/model/mobile/index.js
// module id = 1147
// module chunks = 0